import { useCallback } from 'react';

import { snackbar } from '@occc-app/design-system';

import { CreateLocationGroupAndAddLocationsDialog } from './create-location-group-and-add-locations-dialog.component';
import { CreateLocationGroupFormValues } from './create-location-group-and-add-locations-dialog.types';

import { useRetailerNetworkLocationGroupCreateMutation } from '../../../../data-access/mutations';

type CreateLocationGroupAndAddLocationsDialogContainerProps = {
  retailerNetworkUuid: string;
  open: boolean;
  onClose: () => void;
};

const CreateLocationGroupAndAddLocationsDialogContainer = ({
  retailerNetworkUuid,
  open,
  onClose,
}: CreateLocationGroupAndAddLocationsDialogContainerProps) => {
  const [createLocationGroup, { loading }] = useRetailerNetworkLocationGroupCreateMutation({
    onCompleted: () => snackbar.success('Location group has been created.'),
    onError: () => snackbar.error('Unable to create Location Group. Please try a different name.'),
    refetchQueries: ['retailerNetworkLocationGroups'],
  });

  const onSubmit = useCallback(
    async ({ name, locations }: CreateLocationGroupFormValues) => {
      const locationUuids = locations?.map((location) => location.uuid) ?? [];

      await createLocationGroup({
        variables: {
          retailerNetworkUuid,
          locationGroup: {
            name,
            locationUuids,
          },
        },
      });
      onClose();
    },
    [createLocationGroup, retailerNetworkUuid, onClose],
  );

  return (
    <CreateLocationGroupAndAddLocationsDialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
      retailerNetworkUuid={retailerNetworkUuid}
    />
  );
};

export default CreateLocationGroupAndAddLocationsDialogContainer;
